import type { EmailField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@onclicks/sharedcomponents/ui/Input'
import { Label } from '@onclicks/sharedcomponents/ui/Label'
import React from 'react'

import { Error } from '@onclicks/sharedcomponents/FieldForm/Error'

export const Email: React.FC<
  EmailField & {
    errors: Partial<FieldErrorsImpl>
    placeholder?: string
    register: UseFormRegister<FieldValues>
  }
> = ({ name, defaultValue, errors, label, placeholder, register, required }) => {
  return (
    <div className="flex flex-col gap-2">
      <Label
        htmlFor={name}
        className="text-xs font-semibold tracking-[0.2em] text-neutral-500 uppercase"
      >
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <Input
        defaultValue={defaultValue}
        id={name}
        type="text"
        placeholder={placeholder}
        className="rounded-none border-0 border-b border-black/30 bg-transparent px-0 py-2 text-sm focus:border-black focus:ring-0 focus-visible:ring-0 placeholder:text-neutral-500"
        {...register(name, { pattern: /^\S[^\s@]*@\S+$/, required })}
      />

      {errors[name] && <Error name={name} />}
    </div>
  )
}
